/* eslint-disable */
import React, { useEffect } from 'react';
import { Link, generatePath, useLocation, useHistory } from 'react-router-dom';
import { Downgraded } from '@hookstate/core';
import {
    List,
    Box,
    Typography,
    IconButton,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
// import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
// import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import SportsBasketballOutlinedIcon from '@mui/icons-material/SportsBasketballOutlined';
import AirplanemodeActiveOutlinedIcon from '@mui/icons-material/AirplanemodeActiveOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import CoPresentOutlinedIcon from '@mui/icons-material/CoPresentOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import EmojiTransportationIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
// import stores
import { handleDrawerClose } from '../../../hookState/ModuleDrawerState';
import { useThemeState, exitTheme } from '../../../hookState/ThemeState';
import {
    useEventState,
    updateModuleState,
    resetState,
    // getUserEventPermissions,
} from '../../../stores/eventStore';
// import utility and constants
import Helper from '../../../utility/helper';
// import ApiHelper from '../../../utility/ApiHelper';
import RouteConstants from '../../../constants/routeConstants';
// import APIURLConstants from '../../../config/config';
// import icons
import Dashboard from '../../../assets/Icons/dashboard.svg';
import Events from '../../../assets/Icons/events.svg';
import Users from '../../../assets/Icons/users.svg';
import Eventdetails from '../../../assets/Icons/eventdetails.svg';
import Private_transport from '../../../assets/Icons/private_transport.svg';

import {
    handleAgentEventClose,
    useAgentState,
} from '../../../hookState/AgentState';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import APIURLConstants from '../../../config/config';
import ApiHelper from '../../../utility/ApiHelper';
import { useMsal } from '@azure/msal-react';
import { unregister } from '../../../registerServiceWorker';
import Logout from '@mui/icons-material/ExitToApp';
import { ScheduleDataService } from '../../../services/ScheduleService';
import outfit from '../../../assets/images/outfit.svg';
import packageJson from '../../../../package.json';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import MovieOutlinedIcon from '@mui/icons-material/MovieOutlined';
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';
import TimeToLeaveOutlinedIcon from '@mui/icons-material/TimeToLeaveOutlined';
import { NO_ACCESS_PERMISSION } from '../../../constants/Constant';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
// import ContactEmergencyOutlinedIcon from '@mui/icons-material/ContactEmergencyOutlined';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ContactUs from '../../../formComponents/contactus';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import TextSnippetOutlined from '@mui/icons-material/TextSnippetOutlined';
import AddCardIcon from '@mui/icons-material/AddCard';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import EventIcon from '@mui/icons-material/Event';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AddHomeOutlinedIcon from '@mui/icons-material/AddHomeOutlined';
import { setActingOnBehalfOfValue, useActingOnBehalfOfValue } from '../../../hookState/ActingOnBehalfDropdown';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';
import { TableChartOutlined } from '@mui/icons-material';
import GroupIcon from '@mui/icons-material/Group';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AppConstants from '../../../constants/appConstants';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
const useStyles = makeStyles(() => ({
    nopointer: {
        textDecoration: 'none',
        fontFamily: 'lato',
    },
    iconClass: {
        height: 20,
    },
    iconWidth: {
        width: 21,
        height: 21,
    },
    backColor: {
        background: '#ccc',
        '&:hover': {
            background: '#ccc',
        },
    },
    nobutton: {
        border: 'none',
        background: 'transparent',
        width: '100%',
        textDecoration: 'none',
        fontFamily: 'lato',
        padding: '0px',
    },
    justifyCenter: {
        display: 'flex',
        justifyContent: 'center',
    }
}));

export default function NavBar() {
    const { instance } = useMsal();
    // console.log("Helper.getStorage('agentUser')",Helper.getStorage('agentUser'), "Helper.getSessionStorage('agentUser')",Helper.getSessionStorage('agentUser'),"Helper.getStorage('agentConnections')",Helper.getStorage('agentConnections'),"Helper.getSessionStorage('agentConnections')",Helper.getSessionStorage('agentConnections'));
    const [open, setOpen] = React.useState(false);
    const [trackerOpen, setTrackerOpen] = React.useState(false);
    const classes = useStyles();
    const themeState = useThemeState();
    const actingOnBehalfOfValue = useActingOnBehalfOfValue()
    const history = useHistory();
    const location = useLocation();
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const agentConnection = Helper.getStorage('agentConnections') ? Helper.getStorage('agentConnections') : Helper.getSessionStorage('agentConnections');
    const [eventID, setEventID] = React.useState(0);
    const [userID, setUserID] = React.useState(0);
    const [showSchedule, setShowSchedule] = React.useState(false);
    const [showPublishedSchedule, setShowPublishedSchedule] = React.useState(false);
    const [showResource, setShowResource] = React.useState(false);
    const [showStaffSchedule, setShowStaffSchedule] = React.useState(false);
    const [showStaffSchedulePermission, setShowStaffSchedulePermission] = React.useState(false);
    const [eventStaffPublished, setEventStaffPublished] = React.useState(false);
    const [showMediaCircuit, setShowMediaCircuit] = React.useState(false);
    const [showCombineActivityTracker, setCombineActivityTracker] = React.useState(false);
    const [activityTrackerDisplayName, setActivityTrackerDisplayName] = React.useState('');
    const [contentCircuitDisplayName, setContentCircuitDisplayName] = React.useState('');
    const [showMC, setShowMC] = React.useState(false);
    const [showStaffModules, setShowStaffModules] = React.useState(false);
    // const [showSocialResp, setShowSocialResp] = React.useState(false);
    const [showPaymentModule, setShowPaymentModule] = React.useState(false);
    const [showActivityTracker, setShowActivityTracker] = React.useState(false);
    const [showRosters, setShowRosters] = React.useState(false);
    const eventState = useEventState();
    // const [modulesPopulated, setModulesPopulated] = React.useState(false);
    const responsiveTheme = useTheme();
    const isMobile = useMediaQuery(responsiveTheme.breakpoints.down('md'));
    const [contactUsOpenDialog, setContactUsOpenDialog] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    // console.log(agentInfo, agentConnection, userInfo, "userInfo",userInfo);
    const [showNotes, setShowNotes] = React.useState(false);
    const [showEventInstruction, setShowEventInstruction] = React.useState(false);
    const [showMyStatsReport, setShowMyStatsReport] = React.useState(false);
    const [showStaffContactListPermission, setShowStaffContactListPermission] = React.useState(false);
    const [showStaffContactListName, setShowStaffContactListName] = React.useState('');
      
    const handleClick = (e) => {
        e.preventDefault();
        setOpen(!open);
    };

    const handleTrackerClick = (e) => {
        e.preventDefault();
        setTrackerOpen(!trackerOpen);
    };

    const handleThemeExit = () => {
        //history.push(RouteConstants.DASHBOARD);
        setEventID(0);
        //setModulesPopulated(false);
        handleAgentEventClose();
        exitTheme();
        handleDrawerClose();
        resetState();
        // if (Helper.isAdminUser(userInfo))
        //     history.push(RouteConstants.EVENTS);
        // else
    };
    useEffect(() => {
        if (location.pathname == '/') {
            handleThemeExit();
        }
        if (userInfo && !(Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
            (userInfo.roles && Helper.isEventStaff(userInfo)))) {
            handleDrawerClose();
        }
        if (
            Helper.getURLSlug() === 'assignActivities' ||
            Helper.getURLSlug() === 'create' ||
            Helper.getURLSlug() === 'allActivities' ||
            Helper.getURLSlug() === 'markActivities' ||
            Helper.getURLSlug() === 'setTimings'
        ) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [location]);

    useEffect(() => {
        if (eventID) {
            getEventConfig(eventID);
        }
    }, [eventID])

    const handleLogout = () => {
        ApiHelper.get(APIURLConstants.SIGN_OUT).then(async (res) => {
            if (res.data) {
                unregister();
                if (Helper.getStorage('chk') == 'aad') {
                    await instance.logoutRedirect();
                    localStorage.clear();
                    window.sessionStorage.clear()
                } else {
                    localStorage.clear();
                    window.sessionStorage.clear()
                    window.location.href = '/';
                }
            }
        });
    };
    useEffect(() => {
        if (
            agentState.get() &&
            userInfo &&
            agentState.visible.value &&
            actingOnBehalfOfValue.triggerEvent.get()
        ) {
            const userID = (agentConnection && agentInfo) ? agentInfo.userID : userInfo.userID; 
            ApiHelper.get(APIURLConstants.GET_PARTICIPANT_INSTRUCTIONS(eventInfo.eventID, userID))
                .then((res) => {
                    setShowEventInstruction(res.data.length > 0);
                });
    
            ApiHelper.get(APIURLConstants.GET_NOTES_USER(eventInfo.eventID, userID))
                .then((res) => {
                    setShowNotes(res.data.length > 0);
                });
        }
    }, [
        userInfo?.userID,
        eventInfo?.eventID,
        agentInfo?.userID,
        agentState.visible.value,
        actingOnBehalfOfValue.triggerEvent.get()
    ]);
    

    useEffect(() => {
        async function getData() {
            if (
                userInfo &&
                eventInfo &&
                eventID != eventInfo.eventID &&
                location.pathname != '/events/agent' &&
                !(
                    Helper.isAdminUser(userInfo)
                )
            ) {
                setEventID(eventInfo.eventID);
                // await getModuleStatus();
                await updateModuleState();

                // let count = await ScheduleDataService.getUserActivityCount(
                //     eventInfo.eventID,
                //     userInfo.userID
                // );
                //console.log("eventInfo", eventInfo);
                // ApiHelper.get(
                //     APIURLConstants.GET_CONFIG()
                // ).then((res) => {
                //     if(res.data){
                //         // console.log(showPaymentModule,"res",res.data.paymentUsers);
                //         let splitArr = res.data.paymentUsers !== null  ? res.data.paymentUsers.split(',') : ''
                //         if(splitArr.length > 0){
                //             splitArr.map((val) => {
                //                 if(parseInt(val) === userInfo.userID){
                //                     setShowPaymentModule(true)
                //                 }
                //             })
                //         }
                //     }
                // });
                ApiHelper.get(
                    APIURLConstants.GET_NOTES_USER(
                        eventInfo.eventID,
                        agentConnection && agentInfo
                            ? agentInfo.userID
                            : userInfo.userID
                    )
                ).then((res) => {
                    // console.log('res', res);
                    setShowNotes(res.data.length > 0 ? true : false);
                });
                ApiHelper.get(
                    APIURLConstants.GET_PARTICIPANT_INSTRUCTIONS(
                        eventInfo.eventID,
                        agentConnection && agentInfo
                            ? agentInfo.userID
                            : userInfo.userID
                    )
                ).then((res) => {
                    // console.log('res', res.data);
                    setShowEventInstruction(res.data.length > 0 ? true : false);
                });
                if (userInfo.roles && Helper.isEventStaff(userInfo)) {
                    getEventModuleByEventStaff(eventInfo, agentConnection, agentInfo, userInfo);
                }
                if (userInfo.roles && Helper.isEventStaff(userInfo)) {
                    if (eventInfo.isStaffPublished) {
                        setShowStaffSchedule(true);
                    } else {
                        ApiHelper.get(
                            APIURLConstants.GET_SCHEDULE_PUBLISHED(
                                eventInfo.eventID,
                                agentConnection && agentInfo
                                    ? agentInfo.userID
                                    : userInfo.userID
                            )
                        )
                            .then((res) => {
                                // console.log(res.data)
                                setEventStaffPublished(res.data)
                            })
                        let staffSchedulePublished =
                            await ScheduleDataService.getUserActivityPublished(
                                eventInfo.eventID,
                                agentInfo ? agentInfo.userID : userInfo.userID,
                                1
                            );
                        setShowStaffSchedule(staffSchedulePublished ? true : false);
                    }
                } else {
                    // if (eventInfo.isPublished) {
                    //     setShowSchedule(true);
                    // } else {
                    //     let schedulePublished =
                    //         await ScheduleDataService.getUserActivityPublished(
                    //             eventInfo.eventID,
                    //             agentConnection && agentInfo
                    //                 ? agentInfo.userID
                    //                 : userInfo.userID,
                    //             0
                    //         );

                    //     setShowSchedule(schedulePublished ? true : false);
                    // }
                    ApiHelper.get(
                        APIURLConstants.GET_EVENT_PARTICIPANT_BY_USER_ID(
                            eventInfo.eventID,
                            agentConnection && agentInfo
                                ? agentInfo.userID
                                : userInfo.userID
                        )
                    )
                        .then(async (res) => {
                            // console.log("res",res,res.data);
                            if (res.data) {
                                // setShowSchedule(res.data.isSchedulePublished)
                                if (res.data.isSchedulePublished) {
                                    // setShowSchedule(true);
                                    let schedulePublished =
                                        await ScheduleDataService.getUserActivityPublished(
                                            eventInfo.eventID,
                                            agentConnection && agentInfo
                                                ? agentInfo.userID
                                                : userInfo.userID,
                                            0
                                        );
                                    setShowSchedule(schedulePublished ? true : false);
                                } else {
                                    setShowSchedule(false);
                                }
                            }
                        })
                    ApiHelper.get(
                        APIURLConstants.GET_SCHEDULE_PUBLISHED(
                            eventInfo.eventID,
                            agentConnection && agentInfo
                                ? agentInfo.userID
                                : userInfo.userID
                        )
                    )
                        .then((res) => {
                            setShowPublishedSchedule(res.data)
                        })
                }
                getResourceCount(eventInfo, agentConnection, agentInfo, userInfo);
                getMediaCircuitParticipant(eventInfo, agentConnection, agentInfo, userInfo);
                // let count = await ScheduleDataService.getUserActivityCount(
                //     eventInfo.eventID,
                //     userInfo.userID
                // );
                // setShowSchedule(count > 0 ? true : false);
                // await getUserEventPermissions(eventInfo.eventID);
            }
            if (
                userInfo &&
                eventInfo &&
                eventID != eventInfo.eventID &&
                location.pathname != '/events/agent' &&
                (Helper.isAdminUser(userInfo) ||
                    (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
                    (userInfo.roles && Helper.isEventStaff(userInfo)))
            ) {
                ApiHelper.get(
                    APIURLConstants.GET_EVENT_USER_EVENT_MODULES_PERMISSION(
                        eventInfo?.eventID,
                        userInfo?.userID,
                        true
                    )
                ).then((res) => {
                    setShowStaffModules(res ? (res.data && res.data.length > 0 ? true : false) : false);
                });

                // ApiHelper.get(
                //     APIURLConstants.GET_CONFIG()
                // ).then((res) => {
                //     if(res.data){
                //         // console.log(showPaymentModule,"res",res.data.paymentUsers);
                //         let splitArr = res.data.paymentUsers !== null  ? res.data.paymentUsers.split(',') : ''
                //         if(splitArr.length > 0){
                //             splitArr.map((val) => {
                //                 if(parseInt(val) === userInfo.userID){
                //                     setShowPaymentModule(true)
                //                 }
                //             })
                //         }
                //     }
                // });
            }
            if (
                userInfo &&
                eventInfo &&
                eventID != eventInfo.eventID &&
                location.pathname != '/events/agent' &&
                (Helper.isAdminUser(userInfo) ||
                    (userInfo.roles && Helper.isEventAdmin(userInfo)))
            ) {
                setEventID(eventInfo.eventID);
                setUserID(userInfo.userID);
                await updateModuleState();
                // let count = await ScheduleDataService.getUserActivityCount(
                //     eventInfo.eventID,
                //     userInfo.userID
                // );
                // setShowSchedule(count > 0 ? true : false);
                if (userInfo.roles && Helper.isEventStaff(userInfo)) {
                    if (eventInfo.isStaffPublished) {
                        setShowStaffSchedule(true);
                    } else {
                        let staffSchedulePublished =
                            await ScheduleDataService.getUserActivityPublished(
                                eventInfo.eventID,
                                agentConnection && agentInfo
                                    ? agentInfo.userID
                                    : userInfo.userID,
                                1
                            );
                        setShowStaffSchedule(staffSchedulePublished ? true : false);
                    }
                } else {
                    ApiHelper.get(
                        APIURLConstants.GET_EVENT_PARTICIPANT_BY_USER_ID(
                            eventInfo.eventID,
                            agentConnection && agentInfo
                                ? agentInfo.userID
                                : userInfo.userID
                        )
                    )
                        .then(async (res) => {
                            // console.log("res",res,res.data);
                            if (res.data) {
                                // setShowSchedule(res.data.isSchedulePublished)
                                if (res.data.isSchedulePublished) {
                                    // setShowSchedule(true);
                                    let schedulePublished =
                                        await ScheduleDataService.getUserActivityPublished(
                                            eventInfo.eventID,
                                            agentConnection && agentInfo
                                                ? agentInfo.userID
                                                : userInfo.userID,
                                            0
                                        );
                                    setShowSchedule(schedulePublished ? true : false);
                                } else {
                                    setShowSchedule(false);
                                }
                            }
                        })
                    // if (eventInfo.isPublished) {
                    //     setShowSchedule(true);
                    // } else {
                    //     let schedulePublished =
                    //         await ScheduleDataService.getUserActivityPublished(
                    //             eventInfo.eventID,
                    //             agentConnection && agentInfo
                    //                 ? agentInfo.userID
                    //                 : userInfo.userID,
                    //             0
                    //         );
                    //     setShowSchedule(schedulePublished ? true : false);
                    // }
                }
                // ApiHelper.get(
                //     APIURLConstants.GET_CONFIG()
                // ).then((res) => {
                //     if(res.data){
                //         // console.log(showPaymentModule,"res",res.data.paymentUsers);
                //         let splitArr = res.data.paymentUsers !== null  ? res.data.paymentUsers.split(',') : ''
                //         if(splitArr.length > 0){
                //             splitArr.map((val) => {
                //                 if(parseInt(val) === userInfo.userID){
                //                     setShowPaymentModule(true)
                //                 }
                //             })
                //         }
                //     }
                // });
                getResourceCount(eventInfo, agentConnection, agentInfo, userInfo);
                getEventModules(eventInfo);
            }
        }
        getData();
        // if (userInfo && eventInfo) {
        //     let count = await ScheduleDataService.getUserActivityCount(
        //         eventInfo.eventID,
        //         userInfo.userID
        //     );
        //     setShowSchedule(count > 0 ? true : false);
        // }

        // await updateModuleState(); -- continuously calling api so commented out code
    }, [userInfo, eventInfo]);
    // console.log("showSchedule",showSchedule, eventInfo, showPublishedSchedule);

    useEffect(() => {
        async function getAgentData() {
            if (
                agentState.get() &&
                userInfo &&
                agentState.visible.value &&
                agentState.user.get().userID != userID &&
                userID != userInfo.userID
            ) {
                setUserID(userInfo.userID);
                // let count = await ScheduleDataService.getUserActivityCount(
                //     eventInfo.eventID,
                //     userInfo.userID
                // );
                // setShowSchedule(count > 0 ? true : false);

                if (userInfo.roles && Helper.isEventStaff(userInfo)) {
                    if (eventInfo.isStaffPublished) {
                        setShowStaffSchedule(true);
                    } else {
                        let staffSchedulePublished =
                            await ScheduleDataService.getUserActivityPublished(
                                eventInfo.eventID,
                                agentConnection && agentInfo
                                    ? agentInfo.userID
                                    : userInfo.userID,
                                1
                            );

                        setShowStaffSchedule(staffSchedulePublished ? true : false);
                    }
                } else {
                    ApiHelper.get(
                        APIURLConstants.GET_EVENT_PARTICIPANT_BY_USER_ID(
                            eventInfo.eventID,
                            agentConnection && agentInfo
                                ? agentInfo.userID
                                : userInfo.userID
                        )
                    )
                        .then(async (res) => {
                            // console.log("res",res,res.data);
                            if (res.data) {
                                // setShowSchedule(res.data.isSchedulePublished)
                                if (res.data.isSchedulePublished) {
                                    // setShowSchedule(true);
                                    let schedulePublished =
                                        await ScheduleDataService.getUserActivityPublished(
                                            eventInfo.eventID,
                                            agentConnection && agentInfo
                                                ? agentInfo.userID
                                                : userInfo.userID,
                                            0
                                        );
                                    setShowSchedule(schedulePublished ? true : false);
                                } else {
                                    setShowSchedule(false);
                                }
                            }
                        })
                    // if (eventInfo.isPublished) {
                    //     setShowSchedule(true);
                    // } else {

                    // }
                }

                getResourceCount(eventInfo, agentConnection, agentInfo, userInfo);

                if (!(Helper.isAdminUser(userInfo) ||
                    (userInfo.roles && Helper.isEventAdmin(userInfo)) ||
                    (userInfo.roles && Helper.isEventStaff(userInfo)))) {
                    getMediaCircuitParticipant(eventInfo, agentConnection, agentInfo, userInfo);
                }
                else {
                    setShowMC(false);
                }

                if (Helper.isAdminUser(userInfo) ||
                    (userInfo.roles && Helper.isEventAdmin(userInfo))) {
                    getEventModules(eventInfo);
                }
                else if (userInfo.roles && Helper.isEventStaff(userInfo)) {
                    getEventModuleByEventStaff(eventInfo, agentConnection, agentInfo, userInfo);
                }
                else {
                    setShowMediaCircuit(false);
                    setShowActivityTracker(false);
                }
            }
        }
        getAgentData();
    }, [agentState]);

    useEffect(() => {
        async function getModuleState() {
            await updateModuleState();
            setTimeout(() => {
                if (userInfo) {
                    ApiHelper.get(APIURLConstants.GET_CONFIG()).then((res) => {
                        if (res.data) {
                            // console.log( "res",res.data);
                            let splitArr =
                                res.data.paymentUsers !== null
                                    ? res.data.paymentUsers.split(',')
                                    : '';
                            if (splitArr.length > 0) {
                                splitArr.map((val) => {
                                    if (parseInt(val) === userInfo.userID) {
                                        setShowPaymentModule(true);
                                    }
                                });
                            }

                            if (res.data.showActivityTracker !== null && res.data.showActivityTracker === "true") {
                                setShowActivityTracker(true)
                            }
                            if (res.data.showRoster !== null && res.data.showRoster === "true") {
                                setShowRosters(true)
                            }
                        }
                    });
                }
            }, 1000);
        }
        getModuleState();
    }, []);
    const redirectToDash = () => {
        setShowMC(false);
        setShowMediaCircuit(false);
        setCombineActivityTracker(false);
        setShowMyStatsReport(false);
        history.push(RouteConstants.DASHBOARD, { rediretDashToHome: true });
        window.sessionStorage.clear()
        Helper.removeSessionStorage('agentConnections');
        Helper.removeSessionStorage('agentUser');
        Helper.setStorage('impInfo', 2);
    };

    const getEventConfig = (eventID) => {
        ApiHelper.get(APIURLConstants.GET_EVENT_MENU_CONFIG_LIST(eventID))
            .then((res) => {
                //console.log('config', res.data);
                let myStatsReport = res.data && res.data.find(i => i.menuName === AppConstants.EVENT_CONFIG_NAME.MY_STATS);
                //console.log('myStatsReport', myStatsReport);
                setShowMyStatsReport(myStatsReport ? myStatsReport?.isActive : false);
            }).catch(err => {
                console.log('Error While fetching event config', err);
            })
    }
    const handleCloseContactUsdialog = () => {
        setContactUsOpenDialog(false);
        const path =
            eventInfo && eventInfo.eventID && eventInfo.eventID !== null
                ? generatePath(RouteConstants.EVENT_DETAIL, {
                    eventID: eventInfo.eventID,
                })
                : generatePath(RouteConstants.DASHBOARD);
        history.push({
            pathname: path,
        });
    };
    const handleContactUs = () => {
        setContactUsOpenDialog(true);
    };

    const getEventModuleByEventStaff = (eventInfo, agentConnection, agentInfo, userInfo) => {
        ApiHelper.get(
            APIURLConstants.GET_EVENT_MODULE_BY_EVENT_STAFF(
                eventInfo.eventID,
                agentConnection && agentInfo
                    ? agentInfo.userID
                    : userInfo.userID
            )
        )
            .then((res) => {
                // console.log("res.data",res.data)  
                if (res.data.length > 0) {
                    res.data && res.data[0].userModulePermissions.map((val) => {
                        if (val.moduleID === 15 && val.permissionID === 2) {
                            setShowMediaCircuit(true)
                            setContentCircuitDisplayName(val.moduleName)
                        }
                        if (val.moduleID === 24 && val.permissionID === 2) {
                            setCombineActivityTracker(true)
                            setActivityTrackerDisplayName(val.moduleName)
                        }
                        if (val.moduleID === 16 && val.permissionID === 2) {
                            setShowStaffSchedulePermission(true)
                        }
                        if(val.moduleID === 30 && val.permissionID === 2){
                            setShowStaffContactListPermission(true)
                            setShowStaffContactListName(val.moduleName)
                        }
                    })
                }
            })
    }

    const getEventModules = (eventInfo) => {
        ApiHelper.get(
            APIURLConstants.GET_EVENT_MODULES(eventInfo?.eventID, 1, false)
        ).then((res) => {
            if (res) {
                const newData = res.data;
                newData && newData.length > 0 &&
                    newData.map((circuit) => {
                        if (circuit.moduleName === 'ContentCircuit') {
                            setShowMediaCircuit(true);
                            setContentCircuitDisplayName(circuit.displayName)
                        }
                        if (circuit.moduleName === 'ActivityTracker') {
                            setCombineActivityTracker(true)
                            setActivityTrackerDisplayName(circuit.displayName)
                        }
                        // if (circuit.moduleName === 'SocialResponsibility') {
                        //     // setShowSocialResp(true);
                        // }
                    });
            }
        });
    }
    const getResourceCount = (eventInfo, agentConnection, agentInfo, userInfo) => {
        ApiHelper.get(
            APIURLConstants.GET_MY_RESOURCE_COUNT(
                eventInfo.eventID,
                agentConnection && agentInfo
                    ? agentInfo.userID
                    : userInfo.userID
            )
        ).then((res) => {
            setShowResource(res.data > 0 ? true : false);
        });
    }

    const getMediaCircuitParticipant = (eventInfo, agentConnection, agentInfo, userInfo) => {
        ApiHelper.get(
            APIURLConstants.GET_MEDIA_CIRCUIT_PARTICIPANT(
                eventInfo.eventID,
                agentConnection && agentInfo
                    ? agentInfo.userID
                    : userInfo.userID
            )
        ).then((res) => {
            setShowMC(res.data && res.data.rows && res.data.rows.length > 0 ? true : false);
        });
    }

    const getModuleIcon = (moduleItem) => {
        let moduleIcon = null;
        switch (moduleItem) {
            case 'CombineRegistration':
            case 'AllStarRegistration':
            case 'DraftRegistration':
                moduleIcon = <NoteAltOutlinedIcon
                    sx={{
                        transform:
                            'rotate(60deg)',
                    }}
                    fontSize="small"
                />;
                break;
            case 'Hotel':
            case 'DraftHotel':
            case 'AllStarHotel':
                moduleIcon = <LocationCityOutlinedIcon fontSize="small" />;
                break;
            case 'FlightInfo':
            case 'DraftFlightInfo':
            case 'Transportation':
            case 'DraftTransportation':
            case 'CombineTransportation':
                moduleIcon = <AirplanemodeActiveOutlinedIcon fontSize="small" />;
                break;
            case 'Credential':
                moduleIcon = <GroupIcon fontSize="small" />;
                break;
            case 'LunchRoom':
                moduleIcon = <LunchDiningIcon fontSize="small" />;
                break;
            case 'GreenRoom':
                moduleIcon = <BadgeOutlinedIcon fontSize="small" />;
                break;
            case 'Outfit':
                moduleIcon = <Box
                    component="img"
                    alt={
                        'OutfitType'
                    }
                    src={
                        outfit
                    }
                    sx={{
                        height: '18px',
                    }}
                />;
                break;
            case 'VIP':
                moduleIcon = <EventOutlinedIcon fontSize="small" />;
                break;
            case 'Ticket':
                moduleIcon = <ConfirmationNumberOutlinedIcon fontSize="small" />;
                break;
            case 'SatNightTransport':
                moduleIcon = <TimeToLeaveOutlinedIcon fontSize="small" />
                break;
            case 'AllStarPrivateTransport':
                moduleIcon = <Box
                    component="img"
                    alt="Private Transport"
                    src={Private_transport}
                    className={
                        classes.iconWidth
                    }></Box>
                break;
            case 'SocialResponsibility':
                moduleIcon = <VolunteerActivismIcon fontSize="small" />;
                break;
            case 'AllStarTicket':
                moduleIcon = <LocalActivityIcon fontSize="small" />;
                break;
            default:
                moduleIcon = null;
                break;

        }
        return moduleIcon;
    }
    // console.log("history.location.pathname",history.location.pathname);
    return (
        <>
            {location &&
                location.pathname !== RouteConstants.SESSION_TIMEOUT ? (
                <Box id='navBar'
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%',
                        overflow: { sm: 'hidden', xs: 'hidden', md: 'none' },
                        minHeight: {
                            md: 'calc(100vh - 70px);',
                            sm: 'none',
                            xs: 'none',
                        },
                        // bgcolor: 'primary.main',
                        // bgcolor: alpha(themeState.primary.value, 0.15),
                        borderRight: '1px solid #D8D8D8',
                        // boxShadow: ' 0px 4px 4px rgba(0, 0, 0, 0.25)',
                        // opacity: 0.3,
                        color: 'fff',
                        fontWeight: '500',
                        width: '250px',
                        '.MuiSvgIcon-root': {
                            fill: themeState.leftnav.value,
                        },
                        backgroundColor: '#DFE3EC',
                        overflow: 'auto',
                        maxHeight: 'calc(100vh - 70px)',
                    }}>
                    <Box>
                        <List
                            sx={{
                                width: '100%',
                            }}
                            component="nav">
                            {themeState.eventEnabled.value &&
                                history.location.pathname != '/events/agent' ? (
                                <>
                                    <Link
                                        to={generatePath(
                                            RouteConstants.EVENT_DETAIL,
                                            { eventID: eventInfo.eventID }
                                        )}
                                        className={classes.nopointer}>
                                        <ListItemButton
                                            onClick={handleDrawerClose}
                                            className={
                                                Helper.getURLSlug() === 'detail'
                                                    ? classes.backColor
                                                    : ''
                                            }>
                                            <ListItemIcon>
                                                <HomeOutlinedIcon fontSize="small" />
                                            </ListItemIcon>
                                            <ListItemText primary="Event Home" />
                                        </ListItemButton>
                                    </Link>
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_HOME_DETAIL,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'EventHomeDetail'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <AddHomeOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Event Home Settings" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_INSTRUCTION,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'EventInstruction'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                <SportsBasketballOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Event Details" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))
                                        )
                                        ? showEventInstruction && (
                                            <Link
                                                to={generatePath(
                                                    RouteConstants.END_USER_EVENT_INSTRUCTION,
                                                    { eventID: eventInfo.eventID }
                                                )}
                                                className={classes.nopointer}>
                                                <ListItemButton
                                                    onClick={handleDrawerClose}
                                                    className={
                                                        Helper.getURLSlug() ===
                                                            'EventInstruction'
                                                            ? classes.backColor
                                                            : ''
                                                    }>
                                                    <ListItemIcon>
                                                        <Box
                                                            component="img"
                                                            alt="Event Allotment"
                                                            src={Eventdetails}
                                                            className={
                                                                classes.iconWidth
                                                            }></Box>
                                                    </ListItemIcon>
                                                    <ListItemText primary="Event Allotment" />
                                                </ListItemButton>
                                            </Link>
                                        )
                                        : null}
                                    {/* add new code here for dynamic loading of module */}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) ?
                                        <>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'left',
                                                    paddingRight: 1,
                                                    marginLeft: '15px',
                                                    gap: '5px',
                                                    margin: '10px'
                                                }}>
                                                <Typography
                                                    variant="h4"
                                                    fontSize={15}
                                                    paddingTop={'1px'}
                                                    color={'#C8102E'}
                                                    fontWeight={500}>
                                                    To Do
                                                </Typography>
                                                <WarningIcon
                                                    style={{
                                                        fill: '#C8102E',
                                                        fontSize: 16,
                                                    }}
                                                />
                                            </Box>
                                        </>
                                        : null}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) &&
                                        history.location.pathname != '/events/agent'
                                        ? eventState.moduleState
                                            .attach(Downgraded)
                                            .get()
                                            .map((moduleInfo) => {
                                                //   console.log(
                                                //       'moduleInfo',
                                                //       moduleInfo
                                                //   );
                                                return (
                                                    <>
                                                        {moduleInfo.modules && moduleInfo.requestStatus == 'To Do' &&
                                                            history.location
                                                                .pathname !=
                                                            '/events/agent' &&
                                                            moduleInfo.modules
                                                                .length > 0
                                                            ? moduleInfo.modules.map(
                                                                (
                                                                    itemModule
                                                                ) => {
                                                                    if (
                                                                        itemModule.module !== 'ContentCircuit' &&
                                                                        itemModule.module !== 'ActivityTracker'
                                                                    ) {
                                                                        const moduleItem =
                                                                            itemModule.module;
                                                                        // console.log("moduleItem", moduleItem);
                                                                        const displayName =
                                                                            itemModule.displayName;
                                                                        const permission =
                                                                            itemModule.permission;
                                                                        const path = generatePath(Helper.getModulePath(moduleItem),
                                                                            {
                                                                                eventID:
                                                                                    eventInfo.eventID,
                                                                            }
                                                                        );

                                                                        return (
                                                                            <>
                                                                                {permission !=
                                                                                    NO_ACCESS_PERMISSION ? (
                                                                                    <Link
                                                                                        key={`module_${moduleItem}`}
                                                                                        to={{
                                                                                            pathname: path,
                                                                                            state: { displayName: displayName }
                                                                                        }}
                                                                                        className={
                                                                                            classes.nopointer
                                                                                        }>
                                                                                        <ListItemButton>
                                                                                            <ListItemIcon>
                                                                                                {getModuleIcon(moduleItem)}
                                                                                            </ListItemIcon>
                                                                                            <ListItemText
                                                                                                primary={
                                                                                                    // moduleItem
                                                                                                    //     .toLowerCase()
                                                                                                    //     .indexOf(
                                                                                                    //         'registration'
                                                                                                    //     ) >
                                                                                                    // -1
                                                                                                    //     ? 'Event Registration'
                                                                                                    //     : displayName
                                                                                                    displayName
                                                                                                }
                                                                                            />
                                                                                        </ListItemButton>
                                                                                    </Link>
                                                                                ) : null}
                                                                            </>
                                                                        );
                                                                    }
                                                                }
                                                            )
                                                            : moduleInfo.requestStatus == 'To Do' ? <span style={{ margin: '20px' }}>-</span> : null}
                                                    </>
                                                );
                                            })
                                        : null}
                                    {/* {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) &&
                                        eventState.permissions &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get() &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get()
                                            .find(
                                                (mod) =>
                                                    mod.module ==
                                                    'SOCIALRESPONSIBILITY' &&
                                                    mod.permission !=
                                                    NO_ACCESS_PERMISSION
                                            ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.SOCIAL_RESPONSIBILITY,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'socialResponsibility'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <VolunteerActivismIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Social Responsibility" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) ?
                                        <>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'left',
                                                    paddingRight: 1,
                                                    marginLeft: '15px',
                                                    gap: '5px',
                                                    margin: '10px'
                                                }}>
                                                <Typography
                                                    variant="h4"
                                                    fontSize={15}
                                                    paddingTop={'1px'}
                                                    color={'#BC8D15'}
                                                    fontWeight={500}>
                                                    Pending
                                                </Typography>
                                                <WatchLaterIcon
                                                    style={{
                                                        fill: '#BC8D15',
                                                        fontSize: 16,
                                                    }}
                                                />
                                            </Box>
                                        </>
                                        : null}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) &&
                                        history.location.pathname != '/events/agent'
                                        ? eventState.moduleState
                                            .attach(Downgraded)
                                            .get()
                                            .map((moduleInfo) => {
                                                //   console.log(
                                                //       'moduleInfo',
                                                //       moduleInfo
                                                //   );
                                                return (
                                                    <>
                                                        {moduleInfo.modules && moduleInfo.requestStatus == 'Pending' &&
                                                            history.location
                                                                .pathname !=
                                                            '/events/agent' &&
                                                            moduleInfo.modules
                                                                .length > 0
                                                            ? moduleInfo.modules.map(
                                                                (
                                                                    itemModule
                                                                ) => {
                                                                    if (
                                                                        itemModule.module !==
                                                                        'ContentCircuit'
                                                                    ) {
                                                                        const moduleItem =
                                                                            itemModule.module;
                                                                        // console.log("moduleItem", moduleItem);
                                                                        const displayName =
                                                                            itemModule.displayName;
                                                                        const permission =
                                                                            itemModule.permission;
                                                                        const path =
                                                                            generatePath(Helper.getModulePath(moduleItem),
                                                                                {
                                                                                    eventID:
                                                                                        eventInfo.eventID,
                                                                                }
                                                                            );
                                                                        return (
                                                                            <>
                                                                                {permission !=
                                                                                    NO_ACCESS_PERMISSION ? (
                                                                                    <Link
                                                                                        key={`module_${moduleItem}`}
                                                                                        to={{
                                                                                            pathname: path,
                                                                                            state: { displayName: displayName }
                                                                                        }}
                                                                                        className={
                                                                                            classes.nopointer
                                                                                        }>
                                                                                        <ListItemButton>
                                                                                            <ListItemIcon>
                                                                                                {getModuleIcon(moduleItem)}
                                                                                            </ListItemIcon>
                                                                                            <ListItemText
                                                                                                primary={
                                                                                                    // moduleItem
                                                                                                    //     .toLowerCase()
                                                                                                    //     .indexOf(
                                                                                                    //         'registration'
                                                                                                    //     ) >
                                                                                                    // -1
                                                                                                    //     ? 'Event Registration'
                                                                                                    //     : displayName
                                                                                                    displayName
                                                                                                }
                                                                                            />
                                                                                        </ListItemButton>
                                                                                    </Link>
                                                                                ) : null}
                                                                            </>
                                                                        );
                                                                    }
                                                                }
                                                            )
                                                            : moduleInfo.requestStatus == 'Pending' ? <span style={{ margin: '20px' }}>-</span> : null}
                                                    </>
                                                );
                                            })
                                        : null}
                                    {/* {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) &&
                                        eventState.permissions &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get() &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get()
                                            .find(
                                                (mod) =>
                                                    mod.module ==
                                                    'SOCIALRESPONSIBILITY' &&
                                                    mod.permission !=
                                                    NO_ACCESS_PERMISSION
                                            ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.SOCIAL_RESPONSIBILITY,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'socialResponsibility'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <VolunteerActivismIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Social Responsibility" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) ?
                                        <>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'left',
                                                    paddingRight: 1,
                                                    marginLeft: '15px',
                                                    gap: '5px',
                                                    margin: '10px'
                                                }}>
                                                <Typography
                                                    variant="h4"
                                                    fontSize={15}
                                                    paddingTop={'1px'}
                                                    color={'#148845'}
                                                    fontWeight={500}>
                                                    Approved
                                                </Typography>
                                                <CheckCircleIcon
                                                    style={{
                                                        fill: '#148845',
                                                        fontSize: 16,
                                                    }}
                                                />
                                            </Box>
                                        </>
                                        : null}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) &&
                                        history.location.pathname != '/events/agent'
                                        ? eventState.moduleState
                                            .attach(Downgraded)
                                            .get()
                                            .map((moduleInfo) => {
                                                //   console.log(
                                                //       'moduleInfo',
                                                //       moduleInfo
                                                //   );
                                                return (
                                                    <>
                                                        {moduleInfo.modules && moduleInfo.requestStatus == 'Approved' &&
                                                            history.location
                                                                .pathname !=
                                                            '/events/agent' &&
                                                            moduleInfo.modules
                                                                .length > 0
                                                            ? moduleInfo.modules.map(
                                                                (
                                                                    itemModule
                                                                ) => {
                                                                    if (
                                                                        itemModule.module !==
                                                                        'ContentCircuit'
                                                                    ) {
                                                                        const moduleItem =
                                                                            itemModule.module;
                                                                        // console.log("moduleItem", moduleItem);
                                                                        const displayName =
                                                                            itemModule.displayName;
                                                                        const permission =
                                                                            itemModule.permission;
                                                                        const path = generatePath(Helper.getModulePath(moduleItem),
                                                                            {
                                                                                eventID:
                                                                                    eventInfo.eventID,
                                                                            }
                                                                        );

                                                                        return (
                                                                            <>
                                                                                {permission !=
                                                                                    NO_ACCESS_PERMISSION ? (
                                                                                    <Link
                                                                                        key={`module_${moduleItem}`}
                                                                                        to={{
                                                                                            pathname: path,
                                                                                            state: { displayName: displayName }
                                                                                        }}
                                                                                        className={
                                                                                            classes.nopointer
                                                                                        }>
                                                                                        <ListItemButton>
                                                                                            <ListItemIcon>
                                                                                                {getModuleIcon(moduleItem)}
                                                                                            </ListItemIcon>
                                                                                            <ListItemText
                                                                                                primary={
                                                                                                    // moduleItem
                                                                                                    //     .toLowerCase()
                                                                                                    //     .indexOf(
                                                                                                    //         'registration'
                                                                                                    //     ) >
                                                                                                    // -1
                                                                                                    //     ? 'Event Registration'
                                                                                                    //     : displayName
                                                                                                    displayName
                                                                                                }
                                                                                            />
                                                                                        </ListItemButton>
                                                                                    </Link>
                                                                                ) : null}
                                                                            </>
                                                                        );
                                                                    }
                                                                }
                                                            )
                                                            : moduleInfo.requestStatus == 'Approved' ? <span style={{ margin: '20px' }}>-</span> : null}
                                                    </>
                                                );
                                            })
                                        : null}
                                    {/* {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) &&
                                        eventState.permissions &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get() &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get()
                                            .find(
                                                (mod) =>
                                                    mod.module ==
                                                    'SOCIALRESPONSIBILITY' &&
                                                    mod.permission !=
                                                    NO_ACCESS_PERMISSION
                                            ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.SOCIAL_RESPONSIBILITY,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'socialResponsibility'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <VolunteerActivismIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Social Responsibility" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {/* {userInfo &&
                                !(
                                    Helper.isAdminUser(userInfo) ||
                                    (userInfo.roles &&
                                        Helper.isEventAdmin(userInfo)) ||
                                    (userInfo.roles &&
                                        Helper.isEventStaff(userInfo))
                                ) ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            paddingTop: 2,
                                            paddingLeft: 2,
                                            height: 36,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                paddingRight: 1,
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={15}
                                                paddingTop={'1px'}
                                                color={'#C81020'}
                                                fontWeight={500}>
                                                To Do
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}>
                                            <WarningIcon
                                                style={{
                                                    fill: '#C81020',
                                                    fontSize: 16,
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                ) : null}
                                {userInfo &&
                                    !(
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))
                                    ) ? (
                                    <Link
                                        to={generatePath(RouteConstants.EVENT_TRANSIT, { eventID: eventInfo.eventID })}
                                        className={classes.nopointer}>
                                        <ListItemButton>
                                            <ListItemIcon>
                                                <AirplanemodeActiveOutlinedIcon
                                                    sx={{
                                                        transform:
                                                            'rotate(60deg)',
                                                    }}
                                                    fontSize="small"
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Transport" />
                                        </ListItemButton>
                                    </Link>
                                ) : null}
                                {userInfo &&
                                    !(
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))
                                    ) ? (
                                    <ListItemButton>
                                        <ListItemIcon>
                                            <ConfirmationNumberOutlinedIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="Tickets" />
                                    </ListItemButton>
                                ) : null}
                                {userInfo &&
                                    !(
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))
                                    ) ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            paddingTop: 2,
                                            paddingLeft: 2,
                                            height: 36,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                paddingRight: 1,
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={15}
                                                paddingTop={'1px'}
                                                color={'#BC8D15'}
                                                fontWeight={500}>
                                                Pending
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}>
                                            <WatchLaterIcon
                                                style={{
                                                    fill: '#BC8D15',
                                                    fontSize: 16,
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                ) : null}
                                {userInfo &&
                                    !(
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))
                                    ) ? (
                                    <Link
                                        to={generatePath(RouteConstants.EVENT_HOTEL, { eventID: eventInfo.eventID })}
                                        className={classes.nopointer}>
                                        <ListItemButton>
                                            <ListItemIcon>
                                                <LocationCityOutlinedIcon fontSize="small" />
                                            </ListItemIcon>
                                            <ListItemText primary="Hotel" />
                                        </ListItemButton>
                                    </Link>
                                ) : null}
                                {userInfo &&
                                    !(
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))
                                    ) ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            paddingTop: 2,
                                            paddingLeft: 2,
                                            height: 36,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                paddingRight: 1,
                                            }}>
                                            <Typography
                                                variant="h4"
                                                fontSize={15}
                                                paddingTop={'1px'}
                                                color={'#2ECC71'}
                                                fontWeight={500}>
                                                Approved
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}>
                                            <CheckCircleIcon
                                                style={{
                                                    fill: '#2ECC71',
                                                    fontSize: 16,
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                ) : null}
                                {userInfo &&
                                    !(
                                        Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))
                                    ) ? (
                                    <Link
                                        to={
                                            generatePath(RouteConstants.EVENT_REGISTER_CREATE, { eventID: eventInfo.eventID })
                                        }
                                        className={classes.nopointer}>
                                        <ListItemButton>
                                            <ListItemIcon>
                                                <AppRegistrationOutlinedIcon fontSize="small" />
                                            </ListItemIcon>
                                            <ListItemText primary="Event Registration" />
                                        </ListItemButton>
                                    </Link>
                                ) : null} */}

                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) &&
                                        history.location.pathname !=
                                        '/events/agent' ? (
                                        <>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    paddingTop: 2,
                                                    paddingLeft: 2,
                                                    height: 36,
                                                }}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        paddingRight: 1,
                                                    }}>
                                                    <Typography
                                                        variant="h4"
                                                        fontSize={15}
                                                        paddingTop={'1px'}
                                                        color={'#858E9F'}
                                                        fontWeight={500}>
                                                        Event Resources
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </>
                                    ) : null}
                                    {/* <Link
                                    to={generatePath(
                                        RouteConstants.EVENT_DETAIL,
                                        { eventID: eventInfo.eventID }
                                    )}
                                    className={classes.nopointer}>
                                    <ListItemButton onClick={handleDrawerClose}>
                                        <ListItemIcon>
                                            <SportsBasketballOutlinedIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText primary="Event Details" />
                                    </ListItemButton>
                                </Link> */}
                                    {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(
                                                    userInfo
                                                )) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) &&

                                        showSchedule && (
                                            <Link
                                                to={generatePath(
                                                    RouteConstants.USER_ACTIVITIES,
                                                    {
                                                        eventID:
                                                            eventInfo.eventID,
                                                    }
                                                )}
                                                className={classes.nopointer}>
                                                <ListItemButton
                                                    onClick={handleDrawerClose}
                                                    className={
                                                        Helper.getURLSlug() ===
                                                            'useractivities'
                                                            ? classes.backColor
                                                            : ''
                                                    }>
                                                    <ListItemIcon>
                                                        <CalendarTodayOutlinedIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Schedule" />
                                                </ListItemButton>
                                            </Link>
                                        )}
                                    {(userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo))
                                        ) &&
                                        showMC) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_MEDIA_CIRCUIT,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'contentCircuit'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <MovieOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Media Circuit" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {(userInfo && userInfo.pcmsPlayerID &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) && showMyStatsReport) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.MY_STATS_REPORT,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'MyStatsReport'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <TableChartOutlined fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="My Stats" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        userInfo.roles &&
                                        Helper.isEventStaff(userInfo) &&
                                        eventStaffPublished &&
                                        showStaffSchedule && showStaffSchedulePermission ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_SCHEDULE,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'useractivities'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <CalendarTodayOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Schedule" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (userInfo.roles &&
                                        Helper.isEventStaff(userInfo) || (
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))
                                        )) && showStaffContactListPermission ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.CONTACT_LIST,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'contactList'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ContactPhoneOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary={showStaffContactListName} />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (userInfo.roles && 
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))
                                        ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.CONTACT_LIST,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'contactList'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ContactPhoneOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary={'Contact List'} />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                        userInfo.roles &&
                                        Helper.isEventStaff(userInfo) &&
                                        showStaffSchedule ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_STAFF_SCHEDULE,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'staff Schedule'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <CalendarTodayOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Staff Schedule" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}

                                    {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))
                                        )
                                        ? showNotes && (
                                            <Link
                                                to={generatePath(
                                                    RouteConstants.EVENT_NOTES_USER,
                                                    {
                                                        eventID:
                                                            eventInfo.eventID,
                                                    }
                                                )}
                                                className={classes.nopointer}>
                                                <ListItemButton
                                                    onClick={
                                                        handleDrawerClose
                                                    }
                                                    className={
                                                        Helper.getURLSlug() ===
                                                            'notes'
                                                            ? classes.backColor
                                                            : ''
                                                    }>
                                                    <ListItemIcon>
                                                        <TextSnippetOutlined fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Notes" />
                                                </ListItemButton>
                                            </Link>
                                        )
                                        : null}

                                    {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        )
                                        ? showResource && (
                                            <Link
                                                to={generatePath(
                                                    RouteConstants.MY_RESOURCE,
                                                    {
                                                        eventID:
                                                            eventInfo.eventID,
                                                    }
                                                )}
                                                className={classes.nopointer}>
                                                <ListItemButton
                                                    onClick={
                                                        handleDrawerClose
                                                    }
                                                    className={
                                                        Helper.getURLSlug() ===
                                                            'myresource'
                                                            ? classes.backColor
                                                            : ''
                                                    }>
                                                    <ListItemIcon>
                                                        <FileCopyOutlinedIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Event Documents" />
                                                </ListItemButton>
                                            </Link>
                                        )
                                        : null}
                                    {userInfo &&
                                        userInfo.roles &&
                                        Helper.isEventAgent(userInfo) ? showResource &&  (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.MY_RESOURCE,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'myresource'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <FileCopyOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Event Documents" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) &&
                                        eventState.permissions &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get() &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get()
                                            .find(
                                                (mod) =>
                                                    mod.module == 'SOCIALRESPONSIBILITY' &&
                                                    mod.permission !=
                                                    NO_ACCESS_PERMISSION
                                            ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.SOCIAL_RESPONSIBILITY,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'socialResponsibility'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <VolunteerActivismIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Social Responsibility" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}   */}


                                    {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.SETTINGS,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'settings'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <SettingsOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Settings" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        history.location.pathname !=
                                        '/events/agent' &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo))
                                        ) ? (
                                        <Box className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={() => {
                                                    handleDrawerClose,
                                                        handleContactUs();
                                                }}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'contactus'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ContactMailIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Contact Us" />
                                            </ListItemButton>
                                        </Box>
                                    ) : null}
                                    {userInfo &&
                                        userInfo.roles &&
                                        Helper.isEventStaff(userInfo) &&
                                        showStaffModules ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.MODULE,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'module'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ViewModuleOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Modules" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                        userInfo.roles &&
                                        Helper.isEventAgent(userInfo) &&
                                        eventState.permissions &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get() &&
                                        eventState.permissions
                                            .attach(Downgraded)
                                            .get()
                                            .find(
                                                (mod) =>
                                                    mod.module ==
                                                    'CONTENTCIRCUIT' &&
                                                    mod.permission !=
                                                    NO_ACCESS_PERMISSION
                                            ) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_MEDIA_CIRCUIT,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'contentCircuit'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <MovieOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Media Circuit" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {/* {userInfo &&
                                        userInfo.roles &&
                                        Helper.isEventStaff(userInfo) &&
                                        showStaffModules ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.MODULE,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'module'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ViewModuleOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Modules" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}

                                    {/* {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.BRANDING_COLOR,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'brandingcolor'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <PaletteOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Branding And Color" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}

                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_PARTICIPANTS,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'participants'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <GroupOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Participants" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_PARTICIPANT_MODULE_STATUS,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'participantModuleStatus'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <CoPresentOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Participant Status" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_PARTICIPANT_MODULE_STATUS_NEW,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'participantModuleStatus'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <CoPresentOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Participant Status" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_SCHEDULE,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'schedule'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <CalendarTodayOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Schedule" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                    (Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        (userInfo.roles &&
                                            Helper.isEventStaff(userInfo))) ? (
                                    <Link
                                        to={generatePath(RouteConstants.USER_ACTIVITIES, { eventID: eventInfo.eventID })}
                                        className={classes.nopointer}>
                                        <ListItemButton
                                            onClick={handleDrawerClose}>
                                            <ListItemIcon>
                                                <CalendarTodayOutlinedIcon fontSize="small" />
                                            </ListItemIcon>
                                            <ListItemText primary="User Activities" />
                                        </ListItemButton>
                                    </Link>
                                ) : null
                                } */}
                                    {/* Comment for All star Staff schedule on 8/9/23 */}
                                    {/* {userInfo &&
                                    (Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_STAFF_SCHEDULE,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                    'Staff Schedule'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <TodayOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Staff Schedule" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}

                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.MODULE,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'module' ||
                                                        Helper.getURLSlug() ===
                                                        'transportation' ||
                                                        Helper.getURLSlug() ===
                                                        'registrations' ||
                                                        Helper.getURLSlug() ===
                                                        'draftregistration' ||
                                                        Helper.getURLSlug() ===
                                                        'invitations' ||
                                                        Helper.getURLSlug() ===
                                                        'hotel' ||
                                                        Helper.getURLSlug() ===
                                                        'outfit' ||
                                                        Helper.getURLSlug() ===
                                                        'ticket' ||
                                                        Helper.getURLSlug() ===
                                                        'allStarTicket' ||
                                                        Helper.getURLSlug() ===
                                                        'drafthotel' ||
                                                        Helper.getURLSlug() ===
                                                        'allStarhotel' ||
                                                        Helper.getURLSlug() ===
                                                        'allstarregistration'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ViewModuleOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Modules" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.MODULE_PERMISSIONS,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'permissions'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <KeyOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Permissions" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_RESOURCE,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'resource'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <FileCopyOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Manage Event Documents" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.Event_Notification,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'notification'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <NotificationsNoneOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Notification" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_NOTES,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'notes'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <TextSnippetOutlined fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Notes" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}

                                    {userInfo &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.TRANSPORT_SUMMARY,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'transportSummary'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <EmojiTransportationIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Transport Summary" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}

                                    {userInfo &&
                                        showActivityTracker &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.ACTIVITY_TRACKER,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'activitytracker'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <TrackChangesIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Activity Tracker" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {userInfo &&
                                         (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.KEY_CONTACTS,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'keycontacts'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <KeyboardCommandKeyIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Key Contacts" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {(userInfo && (showMediaCircuit) &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            Helper.isEventStaff(userInfo))) ? (
                                        <ListItemButton
                                            onClick={handleClick}
                                            className={
                                                Helper.getURLSlug() === 'events'
                                                    ? classes.backColor
                                                    : ''
                                            }>
                                            <ListItemIcon>
                                                <MovieOutlinedIcon fontSize="small" />
                                            </ListItemIcon>
                                            <ListItemText primary={contentCircuitDisplayName && contentCircuitDisplayName} />
                                            <IconButton>
                                                {open ? (
                                                    <ExpandLess />
                                                ) : (
                                                    <ExpandMore />
                                                )}
                                            </IconButton>
                                        </ListItemButton>
                                    ) : null}
                                    {(Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo)) ||
                                        Helper.isEventStaff(userInfo) &&
                                        (showMediaCircuit)) ? (
                                        <Collapse
                                            in={open}
                                            timeout="auto"
                                            unmountOnExit>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.ALL_ACTIVITIES,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'allActivities'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="All Activities" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.ASSIGN_ACTIVITIES,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        onClick={
                                                            handleDrawerClose
                                                        }
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'assignActivities'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Assign Activities" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.SET_TIMINGS,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        onClick={
                                                            handleDrawerClose
                                                        }
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'setTimings'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Set Timings" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.MARK_ACTIVITIES,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        onClick={
                                                            handleDrawerClose
                                                        }
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'markActivities'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Circuit Confirmation Tracker" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                        </Collapse>
                                    ) : null}
                                    {(userInfo && showCombineActivityTracker
                                        && (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            Helper.isEventStaff(userInfo))) ? (
                                        <ListItemButton
                                            onClick={handleTrackerClick}
                                            className={
                                                Helper.getURLSlug() === 'events'
                                                    ? classes.backColor
                                                    : ''
                                            }>
                                            <ListItemIcon>
                                                <TrackChangesIcon fontSize="small" />
                                            </ListItemIcon>
                                            <ListItemText primary={activityTrackerDisplayName && activityTrackerDisplayName} />
                                            <IconButton>
                                                {trackerOpen ? (
                                                    <ExpandLess />
                                                ) : (
                                                    <ExpandMore />
                                                )}
                                            </IconButton>
                                        </ListItemButton>
                                    ) : null}
                                    {(showCombineActivityTracker &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            Helper.isEventStaff(userInfo))) ? (
                                        <Collapse
                                            in={trackerOpen}
                                            timeout="auto"
                                            unmountOnExit>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.COMBINE_ALL_ACTIVITIES,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'combineallActivities'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="All Activity Tracker" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.COMBINE_ASSIGN_ACTIVITIES,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        onClick={
                                                            handleDrawerClose
                                                        }
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'combineassignActivities'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Assign Activity Tracker" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                            <List
                                                component="div"
                                                disablePadding>
                                                <Link
                                                    to={generatePath(
                                                        RouteConstants.COMBINE_MARK_ACTIVITIES,
                                                        {
                                                            eventID:
                                                                eventInfo.eventID,
                                                        }
                                                    )}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        onClick={
                                                            handleDrawerClose
                                                        }
                                                        sx={{ pl: 4 }}
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'combinemarkActivities'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <LocalActivityOutlinedIcon fontSize="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Activity Confirmation Tracker" />
                                                    </ListItemButton>
                                                </Link>
                                            </List>
                                        </Collapse>
                                    ) : null}
                                    {showRosters &&
                                        (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.ROSTERS,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'rosters'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <GroupWorkOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Rosters" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {/* {!(Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo))) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.CREDENTIALS,
                                                { eventID: eventInfo.eventID }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'credentials'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <GroupWorkOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Credentials" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}
                                    {/* {userInfo
                                        && showSocialResp ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.EVENT_SOCIAL_RESPONSIBILITY,
                                                {
                                                    eventID: eventInfo.eventID,
                                                }
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'socialResponsibility'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <VolunteerActivismIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Social Responsibility" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null} */}

                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={() => redirectToDash()}
                                        className={classes.nobutton}>
                                        <ListItemButton //</Link>onClick={handleThemeExit}
                                            sx={{
                                                padding: '8px 16px'
                                            }}
                                        >
                                            <ListItemIcon>
                                                <ExitToAppOutlinedIcon
                                                    fontSize="small"
                                                    sx={{
                                                        transform:
                                                            'rotate(180deg)',
                                                    }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary="Exit From Event" />
                                        </ListItemButton>
                                    </Link>
                                </>
                            ) : (
                                <>
                                    {!Helper.isPaymentUser(userInfo) ? (
                                        <Link
                                            component="button"
                                            variant="body2"
                                            onClick={() => redirectToDash()}
                                            className={classes.nobutton}
                                        >
                                            <ListItemButton
                                                className={
                                                    Helper.getURLSlug() === ''
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <Box
                                                        component="img"
                                                        alt="home"
                                                        src={Dashboard}
                                                        className={
                                                            classes.iconWidth
                                                        }></Box>
                                                </ListItemIcon>
                                                <ListItemText primary="Dashboard" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {!Helper.isPaymentUser(userInfo) ? (
                                        <Link
                                            to={
                                                RouteConstants.IN_APP_NOTIFICATIONS
                                            }
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'appNotifications'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <NotificationsNoneOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="App Notifications" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {history.location.pathname !=
                                        '/events/agent' ? (
                                        <>
                                            {Helper.isAdminUser(userInfo) ? (
                                                <Link
                                                    to={RouteConstants.EVENTS}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'events'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <Box
                                                                component="img"
                                                                alt="events"
                                                                src={Events}
                                                                className={
                                                                    classes.iconWidth
                                                                }></Box>
                                                            {/* <SportsBasketballOutlinedIcon fontSize="small" /> */}
                                                        </ListItemIcon>
                                                        <ListItemText primary="Events" />
                                                        <IconButton
                                                            onClick={
                                                                handleClick
                                                            }>
                                                            {open ? (
                                                                <ExpandLess />
                                                            ) : (
                                                                <ExpandMore />
                                                            )}
                                                        </IconButton>
                                                    </ListItemButton>
                                                </Link>
                                            ) : null}
                                            {Helper.isAdminUser(userInfo) ? (
                                                <Collapse
                                                    in={open}
                                                    timeout="auto"
                                                    unmountOnExit>
                                                    <List
                                                        component="div"
                                                        disablePadding>
                                                        <Link
                                                            to={
                                                                RouteConstants.CREATE_EVENT
                                                            }
                                                            className={
                                                                classes.nopointer
                                                            }>
                                                            <ListItemButton
                                                                sx={{ pl: 4 }}
                                                                className={
                                                                    Helper.getURLSlug() ===
                                                                        'create'
                                                                        ? classes.backColor
                                                                        : ''
                                                                }>
                                                                <ListItemIcon>
                                                                    <CreateOutlinedIcon fontSize="small" />
                                                                </ListItemIcon>
                                                                <ListItemText primary="Create Event" />
                                                            </ListItemButton>
                                                        </Link>
                                                    </List>
                                                </Collapse>
                                            ) : null}
                                            {Helper.isAdminUser(userInfo) ? (
                                                <Link
                                                    to={RouteConstants.USERS}
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'users'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <Box
                                                                component="img"
                                                                alt="users"
                                                                src={Users}
                                                                className={
                                                                    classes.iconWidth
                                                                }></Box>
                                                            {/* <GroupOutlinedIcon fontSize="small" /> */}
                                                        </ListItemIcon>
                                                        <ListItemText primary="Users" />
                                                    </ListItemButton>
                                                </Link>
                                            ) : null}
                                            {Helper.isAdminUser(userInfo) ? (
                                                <Link
                                                    to={
                                                        RouteConstants.CHANGE_USER
                                                    }
                                                    className={
                                                        classes.nopointer
                                                    }>
                                                    <ListItemButton
                                                        className={
                                                            Helper.getURLSlug() ===
                                                                'changeuser'
                                                                ? classes.backColor
                                                                : ''
                                                        }>
                                                        <ListItemIcon>
                                                            <GroupOutlinedIcon
                                                                sx={{
                                                                    width: 24,
                                                                    height: 24,
                                                                }}
                                                            />
                                                            {/* <Box
                                                    component="img"
                                                    alt="users"
                                                    src={Users} className={classes.iconWidth}></Box> */}
                                                            {/* <PersonOutlinedIcon fontSize="small" /> */}
                                                        </ListItemIcon>
                                                        <ListItemText primary="Change User" />
                                                    </ListItemButton>
                                                </Link>
                                            ) : null}
                                        </>
                                    ) : null}
                                    {userInfo &&
                                        !(
                                            Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles &&
                                                Helper.isEventAdmin(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventStaff(userInfo)) ||
                                            (userInfo.roles &&
                                                Helper.isEventAgent(userInfo)) ||
                                            Helper.isPaymentUser(userInfo)
                                        ) ? (
                                        <Box className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={() => {
                                                    handleDrawerClose,
                                                        handleContactUs();
                                                }}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'contactus'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <ContactMailIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Contact Us" />
                                            </ListItemButton>
                                        </Box>
                                    ) : null}
                                    {userInfo &&
                                        (Helper.isPaymentUser(userInfo) ||
                                            showPaymentModule) ? (
                                        <Link
                                            to={generatePath(
                                                RouteConstants.CHARGE_CARD
                                            )}
                                            className={classes.nopointer}>
                                            <ListItemButton
                                                onClick={handleDrawerClose}
                                                className={
                                                    Helper.getURLSlug() ===
                                                        'chargeCard'
                                                        ? classes.backColor
                                                        : ''
                                                }>
                                                <ListItemIcon>
                                                    <AddCardIcon fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText primary="Charge Card" />
                                            </ListItemButton>
                                        </Link>
                                    ) : null}
                                    {isMobile && (
                                        <Link
                                            to=""
                                            onClick={handleLogout}
                                            className={classes.nopointer}>
                                            <ListItemButton>
                                                <Logout
                                                    sx={{
                                                        mr: 1,
                                                    }}
                                                />
                                                <ListItemText primary="Logout" />
                                            </ListItemButton>
                                        </Link>
                                    )}
                                    {/* {Helper.isAdminUser(userInfo) ? (
                                    <Link
                                        to={RouteConstants.SIGNUP}
                                        className={classes.nopointer}>
                                        <ListItemButton>
                                            <ListItemIcon>
                                                <AssignmentIndOutlinedIcon className={classes.iconWidth} />
                                                
                                            </ListItemIcon>
                                            <ListItemText primary="Signup" />
                                        </ListItemButton>
                                    </Link>
                                ) : null} */}
                                </>
                            )}
                        </List>
                    </Box>
                    <Box>
                        <Typography
                            sx={{ color: `${themeState.leftnav.value}` }}
                            fontSize={14}
                            fontWeight={500}
                            paddingLeft={2}
                            alignContent={'center'}>
                            Version : {packageJson.version}
                        </Typography>
                    </Box>
                </Box>
            ) : null}
            {contactUsOpenDialog && (
                <ContactUs
                    title={'Contact Us'}
                    open={contactUsOpenDialog}
                    setSnackBarProps={setSnackBarProps}
                    snackBarProps={snackBarProps}
                    handleClose={handleCloseContactUsdialog}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </>
    );
}
